module.exports = __webpack_public_path__ + "static/img/product_bg1.3780405.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_bg1.png
// module id = yix7
// module chunks = 1